import { render, staticRenderFns } from "./View.vue?vue&type=template&id=44bc5dc8&"
import script from "./View.vue?vue&type=script&lang=js&"
export * from "./View.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44bc5dc8')) {
      api.createRecord('44bc5dc8', component.options)
    } else {
      api.reload('44bc5dc8', component.options)
    }
    module.hot.accept("./View.vue?vue&type=template&id=44bc5dc8&", function () {
      api.rerender('44bc5dc8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Leads/View.vue"
export default component.exports